
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/activity/shoulderplan",
      function () {
        return require("private-next-pages/activity/shoulderplan.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/activity/shoulderplan"])
      });
    }
  